import React from 'react';

interface HBarItem {
  label: string;
  value: number;
  isMe?: boolean;
  color?: string;
  threshold?: number;
}

interface HorizontalBarChartProps {
  data: HBarItem[];
  max?: number;
  unit?: string;
  thresholdLow?: number;
  thresholdHigh?: number;
  defaultColor?: string;
  belowColor?: string;
}

export default function HorizontalBarChart({
  data,
  max,
  unit = '',
  thresholdLow,
  thresholdHigh,
  defaultColor = '#2472C8',
  belowColor = '#B52020',
}: HorizontalBarChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-24 text-text-tertiary text-sm">
        No data available
      </div>
    );
  }

  const maxVal = max ?? Math.max(...data.map(d => d.value)) * 1.1;

  const getColor = (item: HBarItem): string => {
    if (item.color) return item.color;
    if (item.isMe) return '#C25A0A';
    if (thresholdLow !== undefined && item.value < thresholdLow) return belowColor;
    if (thresholdHigh !== undefined && item.value > thresholdHigh) return '#1A6B3A';
    return defaultColor;
  };

  return (
    <div className="space-y-3">
      {data.map((item, i) => {
        const widthPct = Math.max(2, (item.value / maxVal) * 100);
        const barColor = getColor(item);

        return (
          <div key={i} className="flex items-center gap-3">
            <span
              className={`text-xs text-right flex-shrink-0 ${item.isMe ? 'font-semibold text-text-primary' : 'text-text-secondary'}`}
              style={{ width: 160 }}
            >
              {item.label}
            </span>
            <div className="flex-1 bg-gray-100 rounded-full h-2.5 overflow-hidden">
              <div
                className="h-full rounded-full transition-all"
                style={{ width: `${widthPct}%`, backgroundColor: barColor }}
              />
            </div>
            <span className={`text-xs font-medium flex-shrink-0 ${item.isMe ? 'text-text-primary font-semibold' : 'text-text-secondary'}`} style={{ width: 60 }}>
              {item.value}{unit}
            </span>
          </div>
        );
      })}
    </div>
  );
}
